<template>
  <v-sheet elevation="3">
    <v-form v-model="valid">
      <v-container>
        <h2>Business Credentials For - {{ businessData.comoBusinessId}}</h2>
        <v-row>
          <v-col cols="auto" md="4">
            <v-text-field
                v-model="businessData.comoBusinessApiKey"
                label="Como Business Api Key"
                required
                :rules="validationRules"
            ></v-text-field>
            <v-text-field
                v-model="businessData.revelApiCredentials"
                label="Revel API Credentials"
                required
                :rules="validationRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-btn
              :disabled="!valid || submitInProgress"
              :loading="submitInProgress"
              color="success"
              class="ma-2 white--text"
              @click="updateBusiness"
          >
            Update Business
            <v-icon
                right
                dark
            >
              mdi-database-import
            </v-icon>
          </v-btn>
        </v-row>

      </v-container>
    </v-form>
    <v-snackbar
        v-model="errorSnackbar"
    >
      {{errorSnackbarMessage}}
      <template v-slot:action="{ attrs }">
        <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
        v-model="snackbar"
    >
      Business updated successfully
      <template v-slot:action="{ attrs }">
        <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-sheet>

</template>

<script>
import revelRestaurantApi from "@/api/restaurant.api";

export default {
  name: "UpdateBusinessForm",
  mounted(){
    this.businessData = this.$attrs.businessData;
  },
  data: () => ({
    snackbar: false,
    errorSnackbar: false,
    errorSnackbarMessage: 'Business update error',
    businessData: {
      comoBusinessApiKey: null,
      revelApiCredentials: null,
    },
    validationRules: [
      v => !!v || 'Field is required',
    ],
    valid: false,
    submitInProgress: false
  }),
  methods: {
    async updateBusiness() {
      this.submitInProgress = true;
      try {
        await revelRestaurantApi.update(this.businessData);
        this.$emit("businessUpdated", this.businessData);
        this.snackbar = true;
      }
      catch (e) {
        console.log(e.response);
        this.errorSnackbar = true;
        this.errorSnackbarMessage = e.response.data.message? e.response.data.message : e.response.data;
      }
      this.submitInProgress = false;
    }
  }
}
</script>

<style scoped>

</style>
